var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    { staticClass: "form form--has-fixed-group", attrs: { novalidate: "" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.success,
              expression: "success",
            },
          ],
          ref: "success",
          staticClass: "alert alert--success",
        },
        [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(
                _vm.currentUser
                  ? "Your profile has been saved"
                  : "User profile has been updated"
              ) +
              "\n\t\t"
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid" }, [
        _c("div", { staticClass: "col-12 col-md-6" }, [
          _c(
            "fieldset",
            { staticClass: "form__group" },
            [
              _c("legend", [_vm._v("Personal Information")]),
              _vm._v(" "),
              _c("div", { staticClass: "form__group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.firstName,
                      expression: "formData.firstName",
                    },
                    { name: "validate", rawName: "v-validate" },
                  ],
                  staticClass: "form__control",
                  attrs: {
                    id: "first-name",
                    name: "firstName",
                    placeholder: "Enter name here...",
                    required: "",
                  },
                  domProps: { value: _vm.formData.firstName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.formData, "firstName", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "form__label", attrs: { for: "first-name" } },
                  [_vm._v("Name")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form__validation" }, [
                  _vm._v(_vm._s(_vm.errors.first("firstName"))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form__group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.lastName,
                      expression: "formData.lastName",
                    },
                    { name: "validate", rawName: "v-validate" },
                  ],
                  staticClass: "form__control",
                  attrs: {
                    id: "last-name",
                    name: "lastName",
                    placeholder: "Enter surname here...",
                    required: "",
                  },
                  domProps: { value: _vm.formData.lastName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.formData, "lastName", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "form__label", attrs: { for: "last-name" } },
                  [_vm._v("Surname")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form__validation" }, [
                  _vm._v(_vm._s(_vm.errors.first("lastName"))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form__group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.phone,
                      expression: "formData.phone",
                    },
                    { name: "validate", rawName: "v-validate" },
                  ],
                  staticClass: "form__control",
                  attrs: {
                    id: "phone",
                    type: "tel",
                    name: "phone",
                    placeholder: "Enter phone number here...",
                    required: "",
                  },
                  domProps: { value: _vm.formData.phone },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.formData, "phone", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "form__label", attrs: { for: "phone" } },
                  [_vm._v("Telephone")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form__validation" }, [
                  _vm._v(_vm._s(_vm.errors.first("phone"))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form__group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.email,
                      expression: "formData.email",
                    },
                    { name: "validate", rawName: "v-validate" },
                  ],
                  staticClass: "form__control",
                  attrs: {
                    id: "email",
                    type: "email",
                    name: "email",
                    placeholder: "Enter email address here...",
                    required: "",
                  },
                  domProps: { value: _vm.formData.email },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.formData, "email", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "form__label", attrs: { for: "email" } },
                  [_vm._v("Email Address")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form__validation" }, [
                  _vm._v(_vm._s(_vm.errors.first("email"))),
                ]),
              ]),
              _vm._v(" "),
              _c("FileUpload", {
                attrs: { multiple: false, name: "avatar", label: "Avatar" },
                model: {
                  value: _vm.formData.avatar,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "avatar", $$v)
                  },
                  expression: "formData.avatar",
                },
              }),
              _vm._v(" "),
              _c("FormControlOffice", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: { member: _vm.savedFormData.member, name: "office" },
                model: {
                  value: _vm.formData.office,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "office", $$v)
                  },
                  expression: "formData.office",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "form__group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.position,
                      expression: "formData.position",
                    },
                    { name: "validate", rawName: "v-validate" },
                  ],
                  staticClass: "form__control",
                  attrs: {
                    id: "position",
                    name: "position",
                    placeholder: "Enter position here...",
                    required: "",
                  },
                  domProps: { value: _vm.formData.position },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.formData, "position", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "form__label", attrs: { for: "position" } },
                  [_vm._v("Position")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form__validation" }, [
                  _vm._v(_vm._s(_vm.errors.first("position"))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form__group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.website,
                      expression: "formData.website",
                    },
                  ],
                  staticClass: "form__control",
                  attrs: {
                    id: "website",
                    name: "website",
                    placeholder: "Enter your website here...",
                  },
                  domProps: { value: _vm.formData.website },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.formData, "website", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "form__label", attrs: { for: "website" } },
                  [_vm._v("Website")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form__validation" }, [
                  _vm._v(_vm._s(_vm.errors.first("website"))),
                ]),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-6" }, [
          _c("fieldset", { staticClass: "form__group" }, [
            _c("legend", [_vm._v("Profile Information")]),
            _vm._v(" "),
            _c("div", { staticClass: "form__group" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.background,
                    expression: "formData.background",
                  },
                ],
                staticClass: "form__control",
                attrs: { id: "background", name: "background" },
                domProps: { value: _vm.formData.background },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.formData, "background", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "form__label", attrs: { for: "background" } },
                [_vm._v("Background")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form__validation" }, [
                _vm._v(_vm._s(_vm.errors.first("background"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form__group" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.expertise,
                    expression: "formData.expertise",
                  },
                ],
                staticClass: "form__control",
                attrs: { id: "expertise", name: "expertise" },
                domProps: { value: _vm.formData.expertise },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.formData, "expertise", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "form__label", attrs: { for: "expertise" } },
                [_vm._v("Expertise")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form__validation" }, [
                _vm._v(_vm._s(_vm.errors.first("expertise"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form__group" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.career,
                    expression: "formData.career",
                  },
                ],
                staticClass: "form__control",
                attrs: { id: "career", name: "career" },
                domProps: { value: _vm.formData.career },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.formData, "career", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "form__label", attrs: { for: "career" } },
                [_vm._v("Career")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form__validation" }, [
                _vm._v(_vm._s(_vm.errors.first("career"))),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form__group form__group--submit-fixed" }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "wait",
                rawName: "v-wait:disabled",
                value: _vm.waitName,
                expression: "waitName",
                arg: "disabled",
              },
            ],
            staticClass: "btn btn--primary",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.submit.apply(null, arguments)
              },
            },
          },
          [_vm._v("Save Changes")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }